@if (display) {
  <div class="scitis-menu-item-content loading-container">
    <span class="menu-item-icon">
      <span class="fa-solid fa-spinner fa-spin"></span>
    </span>
    <span class="menu-item-title">{{ 'Loading' | translate }} ...</span>
  </div>
}